import React from 'react';
import { lineSpinner } from 'ldrs'

lineSpinner.register()

const LoadingIcon = ({ width = 22, color = 'white' }: { width?: number, color?: string }) => {
    return <l-line-spinner
        speed="1"
        stroke="3"
        size={width}
        color={color}
    ></l-line-spinner>;
}
export default LoadingIcon;